<app-spinner *ngIf="loading"></app-spinner>

<ngx-datatable
  #table
  *ngIf="!loading && rules !== null"
  class="material"
  [rows]="rules"
  [columnMode]="'standard'"
  [headerHeight]="50"
  [scrollbarV]="true"
  [footerHeight]="30"
  [rowHeight]="50"
  [externalSorting]="true"
  [reorderable]="false"
  [rowClass]="getRowClass"
  (sort)="onSort($event)"
  [loadingIndicator]="loadingIndicator"
  (page)="onPage($event, table.bodyComponent.indexes)"
>
  <ngx-datatable-column name="Last Update" prop="lastUpdatedDate" [width]="120">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <span
        *ngIf="row.lastUpdate"
        md-tooltip="{{ row.updatedByUser }}"
        mdTooltipPosition="right"
        >{{ row.lastUpdate.fromNow() }}</span
      >
      <span *ngIf="!row.lastUpdate">-</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Id" prop="ruleId" [width]="100">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <span>{{ row.ruleId.value }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name="Classification"
    prop="classification"
    [width]="450"
    [sortable]="false"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <span [innerHtml]="value"></span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name="Channel"
    prop="channelGroupName"
    [width]="100"
    [sortable]="false"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      {{ row.channelgroupName }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name="Rule"
    prop="value"
    [width]="485"
    [sortable]="false"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <div class="rule" *ngIf="row.for != 4">
        {{ value }}
      </div>
      <div *ngIf="row.for === 4">
        <img
          *ngFor="let picture of row.pictures"
          [src]="picture.pictureURL"
          height="50"
        />
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Type" prop="destination" [width]="75">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <div class="rule">
        {{ value.value }}
      </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    name="Actions"
    [sortable]="false"
    [width]="150"
    *ngIf="disabledEditing === false"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <div *ngIf="canEdit.includes(row.destination.value) || !canEditMagicBox">
        <md-icon
          aria-disabled="true"
          class="link"
          (click)="editRule(row)"
          mdTooltip="Edit"
          >mode_edit</md-icon
        >
        <md-icon
          aria-disabled="true"
          class="link"
          (click)="duplicateRule(row)"
          mdTooltip="Duplicate"
          >content_copy
        </md-icon>
        <md-icon
          *ngIf="row.isActive"
          aria-disabled="true"
          class="link delete"
          (click)="deleteRule(row)"
          mdTooltip="Delete"
          >delete</md-icon
        >
        <md-icon
          *ngIf="!row.isActive"
          aria-disabled="true"
          class="link delete"
          (click)="restoreRule(row)"
          mdTooltip="Restore rule"
          >restore</md-icon
        >
      </div>

      <div *ngIf="!canEdit.includes(row.destination.value) && !canEditMagicBox">
        <md-icon
          aria-disabled="true"
          class="link"
          (click)="editRule(row)"
          mdTooltip="View"
          >assignment</md-icon
        >
      </div>

      <div *ngIf="!canEdit.includes(row.destination.value) && canEditMagicBox">
        <md-icon
          aria-disabled="true"
          class="link"
          (click)="editRule(row)"
          mdTooltip="Edit"
          >mode_edit</md-icon
        >
      </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template>
      <div class="footer-count" *ngIf="total > 0">
        {{ total }} result<span *ngIf="total > 1">s</span>
      </div>
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>
<sk-three-bounce *ngIf="moreLoading"></sk-three-bounce>



// WEBPACK FOOTER //
// ./src/app/pages/magic-box/magic-box-search/magic-box-search.component.html